export const puzzles = [
  [
    {
      trio: ["aid", "rubber", "wagon"],
      answer: "band"
    },
    {
      trio: ["fox", "man", "peep"],
      answer: "hole"
    },
    {
      trio: ["home", "sea", "bed"],
      answer: "sick"
    },
  ],
  [
    {
      trio: ["flake", "mobile", "cone"],
      answer: "snow"
    },
    {
      trio: ["pie", "luck", "belly"],
      answer: "pot"
    },
    {
      trio: ["dust", "cereal", "fish"],
      answer: "bowl"
    }  
  ],
  [
    {
      trio: ["dream", "break", "light"],
      answer: "day"
    },
    {
      trio: ["opera", "hand", "dish"],
      answer: "soap"
    },
    {
      trio: ["cross", "rain", "tie"],
      answer: "bow"
    }  
  ],
  [
    {
      trio: ["print", "berry", "bird"],
      answer: "blue"
    },
    {
      trio: ["peach", "arm", "tar"],
      answer: "pit"
    },
    {
      trio: ["office", "mail", "car"],
      answer: "box"
    }  
  ],
  [
    {
      trio: ["coffee", "bag", "jelly"],
      answer: "bean"
    },
    {
      trio: ["french", "car", "shoe"],
      answer: "horn"
    },
    {
      trio: ["animal", "back", "rat"],
      answer: "pack"
    }  
  ],
  [
    {
      trio: ["coin", "quick", "spoon"],
      answer: "silver"
    },
    {
      trio: ["shock", "shave", "taste"],
      answer: "after"
    },
    {
      trio: ["off", "military", "first"],
      answer: "base"
    }  
  ],
  [
    {
      trio: ["sandwich", "house", "golf"],
      answer: "club"
    },
    {
      trio: ["boot", "summer", "ground"],
      answer: "camp"
    },
    {
      trio: ["master", "toss", "finger"],
      answer: "ring"
    }  
  ],
  [
    {
      trio: ["chamber", "mask", "natural"],
      answer: "gas"
    },
    {
      trio: ["foul", "ground", "mate"],
      answer: "play"
    },
    {
      trio: ["hammer", "gear", "hunter"],
      answer: "head"
    }  
  ],
  [
    {
      trio: ["mill", "tooth", "dust"],
      answer: "saw"
    },
    {
      trio: ["change", "circuit", "cake"],
      answer: "short"
    },
    {
      trio: ["way", "board", "sleep"],
      answer: "walk"
    }  
  ],
  [
    {
      trio: ["basket", "eight", "snow"],
      answer: "ball"
    },
    {
      trio: ["blank", "list", "mate"],
      answer: "check"
    },
    {
      trio: ["tail", "water", "flood"],
      answer: "gate"
    }  
  ],
  [
    {
      trio: ["right", "cat", "carbon"],
      answer: "copy"
    },
    {
      trio: ["pile", "market", "room"],
      answer: "stock"
    },
    {
      trio: ["cover", "arm", "wear"],
      answer: "under"
    }  
  ],
  [
    {
      trio: ["water", "mine", "shaker"],
      answer: "salt"
    },
    {
      trio: ["type", "ghost", "screen"],
      answer: "writer"
    },
    {
      trio: ["man", "glue", "star"],
      answer: "super"
    }  
  ],
  [
    {
      trio: ["horse", "human", "drag"],
      answer: "race"
    },
    {
      trio: ["break", "bean", "cake"],
      answer: "coffee"
    },
    {
      trio: ["wise", "work", "tower"],
      answer: "clock"
    }  
  ],
  [
    {
      trio: ["loser", "throat", "spot"],
      answer: "sore"
    },
    {
      trio: ["cry", "front", "ship"],
      answer: "battle"
    },
    {
      trio: ["roll", "bean", "fish"],
      answer: "jelly"
    }  
  ],
  [
    {
      trio: ["cane", "daddy", "plum"],
      answer: "sugar"
    },
    {
      trio: ["bottom", "curve", "door"],
      answer: "bell"
    },
    {
      trio: ["tomato", "bomb", "picker"],
      answer: "cherry"
    }  
  ],
  [
    {
      trio: ["cracker", "fly", "fighter"],
      answer: "fire"
    },
    {
      trio: ["fight", "control", "machine"],
      answer: "gun"
    },
    {
      trio: ["pea", "shell", "chest"],
      answer: "nut"
    }  
  ],
  [
    {
      trio: ["widow", "bite", "monkey"],
      answer: "spider"
    },
    {
      trio: ["manners", "round", "tennis"],
      answer: "table"
    },
    {
      trio: ["board", "blade", "back"],
      answer: "switch"
    }  
  ],
  [
    {
      trio: ["playing", "credit", "report"],
      answer: "card"
    },
    {
      trio: ["salt", "deep", "foam"],
      answer: "sea"
    },
    {
      trio: ["land", "hand", "house"],
      answer: "farm"
    }  
  ],
  [
    {
      trio: ["broken", "sun", "eye"],
      answer: "glass"
    },
    {
      trio: ["brain", "plant", "horse"],
      answer: "power"
    },
    {
      trio: ["reading", "service", "stick"],
      answer: "lip"
    }  
  ],
  [
    {
      trio: ["head", "street", "dark"],
      answer: "light"
    },
    {
      trio: ["demon", "limit", "way"],
      answer: "speed"
    },
    {
      trio: ["line", "fruit", "sucker"],
      answer: "punch"
    }  
  ],
  [
    {
      trio: ["worm", "shelf", "end"],
      answer: "book"
    },
    {
      trio: ["surprise", "line", "birthday"],
      answer: "party"
    },
    {
      trio: ["stick", "maker", "point"],
      answer: "match"
    }  
  ]
]